import * as React from 'react';

const AngryFace16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.995-.004c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8m0 1.5c-3.58 0-6.5 2.92-6.5 6.5s2.92 6.5 6.5 6.5 6.5-2.92 6.5-6.5-2.92-6.5-6.5-6.5m.556 7.1a.5.5 0 0 1 .668 0l1.738 1.56a.752.752 0 0 1-1.002 1.118l-.736-.659a.5.5 0 0 0-.667 0l-1.462 1.31a.5.5 0 0 1-.67 0L4.687 10.36A.75.75 0 1 1 5.69 9.246l.732.66a.5.5 0 0 0 .669 0zM4.493 5.51a.75.75 0 0 1 1.06 0l.354.354a.75.75 0 0 1-1.06 1.06l-.354-.353a.75.75 0 0 1 0-1.061m5.953 0a.75.75 0 1 1 1.06 1.061l-.353.354a.75.75 0 0 1-1.06-1.06l.353-.354Z"
  }
));
AngryFace16.Size = 16;
AngryFace16.Title = "AngryFace";

export { AngryFace16 as default };
